import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostsKey } from '../../utils/keys';
export const useMemberPosts = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const postsKey = getPostsKey(variables);
    return useInfiniteQuery(postsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.posts.byMember(variables.memberId, { after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useMemberPosts.js.map